import { render, staticRenderFns } from "./SuppliersModal.vue?vue&type=template&id=6bdf2579&scoped=true&"
import script from "./SuppliersModal.vue?vue&type=script&lang=js&"
export * from "./SuppliersModal.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersModal.vue?vue&type=style&index=0&id=6bdf2579&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf2579",
  null
  
)

export default component.exports